import Vue from "vue";

export const PageComponent = Vue.extend({
  data() {
    return {
      email: false,
      password: false
    };
  },

  computed: {
    isValid(): boolean {
      return this.email && this.password;
    }
  },

  methods: {
    updateEmail(_: string, validity: ValidityState) {
      this.email = validity.valid;
    },

    updatePassword(_: string, validity: ValidityState) {
      this.password = validity.valid;
    }
  }
});
